import React, { useState } from 'react'
import styled from '@emotion/styled'
import { array, string } from 'prop-types'

// import components
import CardFeedObject from 'components/CardFeedObject'
import { Chevron } from '@jelly/components'
import { Link } from '@jelly/ui'

//styled components
const OuterWrapper = styled.div`
	padding: 20px 40px 40px;
`
const FeedTitleDesktop = styled.div`
	display: none;

	${({ theme }) => theme.MQ.M} {
		${({ theme }) => theme.header.h3};
		display: block;
		font-weight: 100;
		padding: 30px 0;
	}
`
const MobileTitleWrapper = styled(Link)`
	cursor: pointer;
`
const FeedTitleMobile = styled.div`
	${({ theme }) => theme.text.sectionHeaderSmall};
	color: ${({ theme }) => theme.colors.secondary};
	display: inline-block;
	padding-bottom: 20px;
	transition: all 0.5s ease;

	${({ theme }) => theme.MQ.M} {
		display: none;
	}
`
const Arrow = styled.span`
	display: inline-block;
	padding: 2px 10px 5px;
	transition: all 0.5s ease;
	width: 15px;

	${({ theme }) => theme.MQ.M} {
		display: none;
	}
`
const FeedWrapper = styled.div`
	display: flex;
	flex-wrap: wrap;
	justify-content: space-between;
	margin-bottom: 1rem;
	transition: all 0.5s ease;
	width: 100%;
`
const BrowseButton = styled(Link)`
	${({ theme }) => theme.buttons.default};
	margin: 20px auto 10px;

	&:hover {
		background: ${({ theme }) => theme.colors.primary};
	}

	${({ theme }) => theme.MQ.M} {
		margin: 0 auto;
	}
`

ToolCard.propTypes = {
	cta: string,
	feed: array,
	title: string,
	url: string,
}

/**
 * This is a Tool Card component primarily used for landing pages, takes card title,
 * description and related content feed. It is ususally placed above footer.
 */
function ToolCard({ title, url, cta, feed }) {
	const [mobileCollapse, setShouldMobileCollapse] = useState(true)

	const handleMobileFeed = () => {
		setShouldMobileCollapse(!mobileCollapse)
	}
	return (
		<OuterWrapper>
			<FeedTitleDesktop>{'Latest Articles'}</FeedTitleDesktop>
			<MobileTitleWrapper onClick={handleMobileFeed}>
				<FeedTitleMobile>{mobileCollapse ? 'Read More' : 'Read Less'}</FeedTitleMobile>
				<Arrow>
					<Chevron rotationDeg={mobileCollapse ? 180 : 0} />
				</Arrow>
			</MobileTitleWrapper>
			<FeedWrapper mobileCollapse={mobileCollapse}>
				{feed.map((feedObject, i) => {
					return <CardFeedObject {...feedObject} type={title} key={i} mobileCollapse={mobileCollapse} />
				})}
			</FeedWrapper>
			<BrowseButton className="Browse" href={url}>
				{cta}
			</BrowseButton>
		</OuterWrapper>
	)
}

export default ToolCard
